<h2 mat-dialog-title>
  <mat-icon>sync</mat-icon>
  Atualizar Base de Zoneamento
</h2>

<mat-dialog-content>
  <p class="dialog-description">
    Selecione o modo de atualização da base de zoneamento ZARC (Embrapa). Cada
    combinação <strong>município × cultura</strong> da área de monitoramento
    gera uma requisição à API.
  </p>

  <mat-divider></mat-divider>

  <mat-radio-group
    class="mode-radio-group"
    [ngModel]="executionMode()"
    (ngModelChange)="executionMode.set($event)"
    aria-label="Modo de execução"
  >
    <mat-radio-button value="INCREMENTAL" class="mode-radio-option">
      <span class="option-label">Processar somente registros pendentes</span>
      <span class="option-hint">
        Consulta apenas os pares município × cultura ainda sem dados na base.
        Mais rápido e preserva o saldo de requisições.
      </span>
    </mat-radio-button>

    <mat-radio-button value="FULL" class="mode-radio-option">
      <span class="option-label"
        >Reprocessar todos os municípios da área de monitoramento</span
      >
      <span class="option-hint">
        Apaga e substitui todos os dados de zoneamento existentes. Usa mais
        requisições do plano.
      </span>
    </mat-radio-button>
  </mat-radio-group>

  <p class="warning-text">
    <mat-icon class="warning-icon">warning_amber</mat-icon>
    Esta operação consome requisições do seu plano mensal de API. Verificar o
    saldo disponível antes de confirmar.
  </p>

  <p class="background-info">
    <mat-icon>info_outline</mat-icon>
    O processo será executado em segundo plano. Você poderá continuar usando o
    sistema e será notificado ao concluir.
  </p>
</mat-dialog-content>

<div class="dialog-actions">
  <button mat-stroked-button type="button" (click)="cancel()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" (click)="confirm()">
    <mat-icon>play_arrow</mat-icon>
    Executar atualização
  </button>
</div>
